import { ref, provide, inject } from 'vue'

const EXPANSION_KEY = Symbol('docExpansion')

export function provideDocExpansion() {
  const expandAll = ref(null)

  const triggerExpandAll = (state) => {
    expandAll.value = { state, timestamp: Date.now() }
  }

  provide(EXPANSION_KEY, {
    expandAll,
    triggerExpandAll
  })

  return { triggerExpandAll }
}

export function injectDocExpansion() {
  return inject(EXPANSION_KEY, null)
}
